/**
 * Move item with given key/value to the top of the array
 * @param {Array} arr - array of objects
 * @param {string} key - key name to match on (eg: 'id' or 'type')
 * @param {*} value - value the item must match
 * @returns {Array}
 */
export function bringItemToTop(arr, key, value) {
	const clone = [...arr];
	const index = clone.findIndex(
		(item) => item[key]?.toLowerCase() === value?.toLowerCase()
	);

	if (index === -1) return clone;

	const [item] = clone.splice(index, 1);
	clone.unshift(item);

	return clone;
}
